"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const ModuleConstants_1 = require("./ModuleConstants");
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(`${Settings_1.default.api.content}/v1/modules`, {
    get: {
        [ModuleConstants_1.ModuleEndpointKeys.GetModulesByClass]: '/by-class/:id/summarized',
        [ModuleConstants_1.ModuleEndpointKeys.GetModulesSummarized]: '/summarized?page=:page&size=:size'
    }
});
